import React from 'react'

import FormError from "../../../../../../../core/gd-form/common/form-error/form-error"
import FormManager from "../../../../../../../core/gd-form/common/form-manager"

// @ts-ignore
import SelectMultiGeneric from "../../../../../../../core/gd-ui/select-multi-generic/select-multi-generic"

type Props = {
    form                    : FormManager
    formFieldName           : string

    disabled?               : boolean
}

export default function SelectProjectTemplatesMulti(props: Props) {

    const templates = gd.session.templatesList.filterByCompany(gd.companyId)
    const options = _.map(templates.models, t=>({
        value: t.id,
        label: t.name
    }))

    return (
        <div className="row">
            <div className="label">Templates</div>
            <div className="element">
                <SelectMultiGeneric form            = {props.form}
                                    name            = {props.formFieldName}
                                    options         = {options}
                                    renderValue     = "form"
                                    placeholder     = {"All templates"}
                                    canHaveNoValue  = {true}
                                    noValueValue    = {[]}
                                    noValueLabel    = "All templates"
                                    searchable      = {false}
                                    disabled        = {props.disabled}/>
                <FormError form={props.form} name={props.formFieldName} />
            </div>
        </div>
    )
}